export default {
    // 消息中间件资源类型查询接口
    listExtendInfos(params, response) {
        return window.vue.$apiAxios.postRequestBody('/auth/extend/getExtendInfo', params, response);
    },
    // 消息中间件资源类型查询接口
    listModuleInfos(params, response) {
        return window.vue.$apiAxios.postRequestBody('/auth/extend/getModuleInfos', params, response);
    },
    // 消息中间件资源类型查询接口
    insertExtendInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/auth/extend/insertExtendInfo', params, response);
    },
    // 消息中间件资源类型查询接口
    insertModuleInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/auth/extend/insertModuleInfo', params, response);
    },
    // 消息更新接口
    getSysList(params, response) {
        return window.vue.$apiAxios.postRequestBody('/auth/sys/getSysList', params, response);
    },
    // 获取最大扩展排序值
    getMaxExtendOrder(params, response) {
        return window.vue.$apiAxios.postRequestBody('/auth/extend/getMaxExtendOrder', params, response);
    },
    // 获取最大模块排序值
    getMaxModuleOrder(params, response) {
        return window.vue.$apiAxios.postRequestBody('/auth/extend/getMaxModuleOrder', params, response);
    },
    // 消息更新接口
    deleteModuleInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/auth/extend/deleteModuleInfo', params, response);
    },
    // 消息更新接口
    deleteExtendInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/auth/extend/deleteExtendInfo', params, response);
    },
    //初始化校验规则
    getRegexList(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/getRegexList', params, response);
    }
};
